import { ChevronDown } from "lucide-react";

/**
 * Hero with full-screen self-hosted background video.
 * Replaces YouTube embed for full creative control & no third-party throttling.
 */
const HeroVideo = () => {
  // Self-hosted MP4 (H.264 + AAC, remuxed from the original .mov for cross-browser compat)
  const videoSrc = "/assets/video/manzano-hero.mp4";

  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative w-full h-screen min-h-[600px] overflow-hidden bg-black"
    >
      {/* Background video — covers full viewport */}
      <video
        data-testid="hero-video"
        src={videoSrc}
        poster="/assets/video/manzano-hero-poster.jpg"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-cover z-0"
      />

      {/* Dark overlay for legibility */}
      <div className="absolute inset-0 z-10 bg-gradient-to-b from-black/60 via-black/30 to-black/60 pointer-events-none" />

      {/* Hero content */}
      <div className="relative z-20 h-full flex flex-col justify-end pb-24 md:pb-32 px-6 md:px-12 max-w-[1400px] mx-auto">
        <div className="max-w-3xl">
          <p
            data-testid="hero-overline"
            className="text-white/70 text-[11px] tracking-[0.4em] uppercase mb-8 font-medium"
          >
            California &middot; Est. Excellence
          </p>
          <h1
            data-testid="hero-heading"
            className="font-heading text-white text-5xl sm:text-6xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tight"
          >
            Your Home Court
            <br />
            <em className="italic font-light">Advantage</em>
          </h1>
          <div className="mt-12 flex flex-col sm:flex-row gap-4 sm:items-center">
            <button
              data-testid="hero-cta-explore"
              onClick={() =>
                document.getElementById("listings")?.scrollIntoView({ behavior: "smooth" })
              }
              className="inline-flex items-center justify-center px-10 py-4 bg-transparent text-white border border-white/80 text-[11px] uppercase tracking-[0.28em] font-medium hover:bg-white hover:text-black transition-all duration-500"
            >
              Explore Listings
            </button>
            <button
              data-testid="hero-cta-contact"
              onClick={() =>
                document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })
              }
              className="inline-flex items-center justify-center px-10 py-4 bg-white text-black text-[11px] uppercase tracking-[0.28em] font-medium hover:bg-black hover:text-white border border-white transition-all duration-500"
            >
              Get In Touch
            </button>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-20 text-white/70 flex flex-col items-center gap-2 animate-pulse pointer-events-none">
        <span className="text-[10px] uppercase tracking-[0.4em]">Scroll</span>
        <ChevronDown size={16} />
      </div>
    </section>
  );
};

export default HeroVideo;
